// extracted by mini-css-extract-plugin
export default {"asteriks":"Label_asteriks__Ic9ZF","bigLabel":"Label_bigLabel__yFcNA"};